import { Badge } from "../../components/ui/badge";
import { Button } from "../../components/ui/button";
import { Square, Globe, Timer, Wifi, WifiOff } from "lucide-react";

export function SessionHeader({ wsConnected, selectedLanguage, sessionTimer, onEndConversation }) {
  const getLanguageLabel = () => {
    switch (selectedLanguage) { case 'hinglish': return 'Hinglish'; case 'hi': return 'Hindi'; default: return 'English'; }
  };
  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <div className="flex items-center gap-4">
      <div className="flex items-center gap-1" data-testid="ws-status">
        {wsConnected ? <Wifi className="w-3.5 h-3.5 text-[#14B8A6]" /> : <WifiOff className="w-3.5 h-3.5 text-red-400" />}
        <span className={`text-xs font-medium ${wsConnected ? 'text-[#14B8A6]' : 'text-red-400'}`}>
          {wsConnected ? 'Live' : 'Reconnecting'}
        </span>
      </div>
      <Badge variant="outline" className="text-xs bg-[#2563EB]/5 text-[#2563EB] border-[#2563EB]/20">
        <Globe className="w-3 h-3 mr-1" />{getLanguageLabel()}
      </Badge>
      <div className="flex items-center gap-2 text-sm text-slate-500">
        <Timer className="w-4 h-4" />
        <span className="font-mono font-medium text-[#0B1F3B]">{formatTime(sessionTimer)}</span>
      </div>
      <Button variant="destructive" onClick={onEndConversation} className="bg-red-500 hover:bg-red-600" data-testid="end-conversation-btn">
        <Square className="w-4 h-4 mr-2" /> End & Evaluate
      </Button>
    </div>
  );
}
